declare var $: any;
// import * as ytp from 'yt-player';
import Vimeo from '@vimeo/player';
import { setTimeout } from 'timers';
import 'core-js/es/array';

export class VideoFunctions {

  private vimeoPlayer: Vimeo | null = null;
  private invokeEvent: any = null;

  setupVideos() {

    const videos = Array.from(document.querySelectorAll('.member-play'));

    videos.forEach((video: any) => {

      const id: string = video.id.substring(12);

      // video.removeEventListener('click', () => {
        // this.loadVideo(id);
      // });
      video.addEventListener('click', () => {
        this.loadVideo(id);
      });

    });

    const modalParent = document.querySelector('#modalParent');
    if (modalParent) {
      // modalParent.removeEventListener('click', this.closeModalIfClickOutside);
      modalParent.addEventListener('click', this.closeModalIfClickOutside.bind(this));
    }

  }

  closeModalIfClickOutside(event: any) {
    const theevent = event || window.event;
    const { target: eventtarget } = theevent;
    if ($(eventtarget).hasClass('video-modal-container') ||
      $(eventtarget).hasClass('video-modal-close')) {

      if (this.vimeoPlayer) {
        this.pauseVideo();
      }

      $('.video-modal-dialog').removeClass('invoked');
      $('body').removeClass('noscroll');
      $('body').removeClass('modal-overlay');

      setTimeout(
        () => {
          $('.video-modal-dialog').addClass('loaded');
        },
        400,
      );

    }
  }

  playVideo() {
    if (this.vimeoPlayer) {
      const vp = this.vimeoPlayer;
      vp.getPaused().then((paused) => {
        if (paused) {
          vp.play();
        }
      });
    }
  }

  pauseVideo() {
    if (this.vimeoPlayer) {
      const vp = this.vimeoPlayer;
      vp.getPaused().then((paused) => {
        if (!paused) {
          vp.pause();
        }
      });
    }
  }

  loadVideo(id: string) {

    $('#vimeo-player').height($('#vimeo-player').width() * 0.56);
    $('.video-modal-dialog').addClass('invoked');
    $('body').addClass('modal-overlay');
    $('body').addClass('noscroll');

    if (this.vimeoPlayer) {
      this.vimeoPlayer.off('loaded', this.invokeEvent);
      // Note - this destroys the iframe
      this.vimeoPlayer.destroy();
    }

    $('#vimeo-player').attr('data-vimeo-id', id);

    const options = {};

    this.vimeoPlayer = new Vimeo($('#vimeo-player'), options);
    this.invokeEvent = this.playVideo.bind(this);
    this.vimeoPlayer.on('loaded', this.invokeEvent);

    // const playerOptions: object = {
    //  controls: true,
    //  info: false,
    //  modestBranding: true,
    //  fullscreen: true,
    //  related: false,
    //  playsInline: true,
    //  captions: false,
    // };

    // const player: any = new ytp('#video-player', playerOptions);
    // player.load(id);
    // player.play();
  }

}
